import script from "./CorporatePageViewStatsCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./CorporatePageViewStatsCard.vue?vue&type=script&lang=ts&setup=true"

import "./CorporatePageViewStatsCard.vue?vue&type=style&index=0&id=04b500f7&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04b500f7"]])

export default __exports__